/* istanbul ignore file */
export * from './FilterSettingsDesktopButton';
